// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleContextInputCourseId } from './moduleContextInputCourseId';
import type { ModuleContextInputCurrentTaskId } from './moduleContextInputCurrentTaskId';

/**
 * Context for a specific module
 */
export interface ModuleContextInput {
  moduleId: string;
  courseId?: ModuleContextInputCourseId;
  currentTaskId?: ModuleContextInputCurrentTaskId;
}
